var floor = require('./floor')

/**
 * 和 Number.toFixed 类似，区别就是不会对小数进行四舍五入，结果返回数值
 *
 * @param { String/Number } str 数值
 * @return {String}
 */
function toFixedNumber (str, digits) {
  return floor(str, digits)
}

module.exports = toFixedNumber



//////////////////
// WEBPACK FOOTER
// ./~/_xe-utils@2.8.3@xe-utils/methods/number/toFixedNumber.js
// module id = 1929
// module chunks = 106